// extracted by mini-css-extract-plugin
export default {"block":"Rk","flex":"Sk","radio":"Tk","label":"Uk","error":"Vk","extra":"Wk"};